import { grayscale } from "./grayscale";
import { material } from "./material";
export * from "./types";
export var VictoryTheme = {
  grayscale: grayscale,
  material: material
};